export default {
    computed: {
        currencySymbol() {
            return this.$store.getters.currencySymbol;
        }
    }
}